import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';
import { GetServiceCaller } from '../../../../services/serviceCaller';
import Dynamic_PR_table from '../../../../components/Dynamic_PR_table';
import { API_URL } from '../../../../constants';


const AssetAllocationList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const passedState = location.state;
    const [originalData, setOriginalData] = useState([]);

    useEffect(() => {
        dispatch(updateNavbarHeading(passedState ? passedState?.text : "Asset Allocation"))
    }, [passedState])
    const [searchTerm, setSearchTerm] = useState("");
    const [assetAllocationListData, setAssetAllocationListData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiStatus, SetApiStatus] = useState(undefined);
    console.log("assetAllocationListData", assetAllocationListData);

    const columns = {
        AllocatedToName: { text: "Allocated To", align: "start", visible: true },
        AssetName: { text: "Assets", align: "left", width: "100px", visible: true },
        CategoryName: { text: "Category", align: "left", visible: true },
        Brand: { text: "Make", align: "left", visible: true },
        BatchNo: { text: "Serial No.", align: "left", visible: true },
        TXNDate: { text: "Allocation Date", align: "center", width: "80px", visible: true },
        AllocatedFromName: { text: "Assing By", align: "left", visible: true },
        Location: { text: "Location", align: "left", visible: true },
    };
    useEffect(() => {
        fetchGetAssetAllocationData();
    }, []);



    useEffect(() => {
        if (originalData.length === 0) return;

        const queryParams = new URLSearchParams(location.search);
        const catName = queryParams.get('CategoryName');


        const filteredData = originalData.filter(item => {


            const Fstatus = catName
                ? item.CategoryName?.trim()?.toLowerCase() === catName?.trim()?.toLowerCase()
                : true;


            return Fstatus;
        });
        console.log("filteredData", filteredData);

        setAssetAllocationListData(filteredData);
    }, [location.search, originalData]);

    const fetchGetAssetAllocationData = async () => {

        try {
            const response = await GetServiceCaller(`${API_URL}asset-allocation`);
            SetApiStatus(response?.status);

            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setAssetAllocationListData(cleanedData);
                setOriginalData(cleanedData)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Asset Allocation. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Asset Allocation:", error);
        }
    };


    const handleEdit = (id) => {
        navigate(`/asset-allocation/edit/${id.AssetAllocationID}`)
    }
    const handleAddNewVendor = () => {
        navigate(`/asset-allocation/add`)
    }

    return (
        <>

            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={assetAllocationListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            showIcon1={true}
                            showIcon2={false}
                            isSorting={true}
                            isActionRequired={true}
                            isAddNewBtnRequired={true}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleIcon1={handleEdit}
                            handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>

        </>
    )
}

export default AssetAllocationList